import { motion } from 'framer-motion';

import { ACCENT_BLUE, GOLD, NOPING_GREEN } from '../constants';

function getStarSize(i: number): number {
  if (i % 7 === 0) return 4;
  if (i % 5 === 0) return 3;
  if (i % 3 === 0) return 2;
  return 1;
}

function getStarColor(i: number): string {
  if (i % 4 === 0) return ACCENT_BLUE;
  if (i % 7 === 0) return NOPING_GREEN;
  if (i % 11 === 0) return GOLD;
  return '#fff';
}

function getStarShadow(i: number): string {
  if (i % 3 !== 0) return 'none';
  const radius = i % 7 === 0 ? 8 : 5;
  const shadowColor = getStarColor(i);
  return `0 0 ${radius}px ${shadowColor}`;
}

function getStreakColor(i: number): string {
  if (i % 3 === 0) return ACCENT_BLUE;
  if (i % 3 === 1) return NOPING_GREEN;
  return '#fff';
}

function getStreakHeight(i: number): number {
  if (i % 6 === 0) return 3;
  if (i % 3 === 0) return 2;
  return 1;
}

export function StarWarsBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' style={{ zIndex: 0 }}>
      <div className='absolute inset-0' style={{ background: `radial-gradient(ellipse 90% 70% at 50% 30%, ${ACCENT_BLUE}0A, transparent 70%)` }} />
      {Array.from({ length: 180 }).map((_, i) => (
        <motion.div key={`sw-star-${i}`} className='absolute rounded-full' style={{ width: getStarSize(i), height: getStarSize(i), left: `${(i * 37.73) % 100}%`, top: `${(i * 61.29) % 100}%`, background: getStarColor(i), boxShadow: getStarShadow(i) }} animate={{ opacity: [0.15, 0.85, 0.15] }} transition={{ duration: 1.2 + (i % 7) * 0.5, delay: (i % 11) * 0.4, repeat: Infinity, ease: 'easeInOut' as const }} />
      ))}
      {Array.from({ length: 50 }).map((_, i) => (
        <motion.div key={`sw-streak-${i}`} className='absolute' style={{ top: `${(i * 7.3) % 100}%`, left: 0, width: 60 + (i % 5) * 40, height: getStreakHeight(i), background: `linear-gradient(to right, transparent, ${getStreakColor(i)}60, transparent)` }} animate={{ x: ['-20vw', '120vw'], opacity: [0, 0.7, 0] }} transition={{ duration: 2.5 + (i % 4) * 1.2, delay: (i % 8) * 0.9, repeat: Infinity, ease: 'linear' as const }} />
      ))}
      <div className='absolute start-6 top-[5%] h-[30%] w-[3px] opacity-20' style={{ background: `linear-gradient(to bottom, transparent, ${ACCENT_BLUE}, transparent)`, filter: 'blur(1px)' }} />
      <div className='absolute end-6 top-[50%] h-[28%] w-[3px] opacity-20' style={{ background: `linear-gradient(to bottom, transparent, ${NOPING_GREEN}, transparent)`, filter: 'blur(1px)' }} />
      <div className='absolute start-1/4 top-[35%] h-1/5 w-[2px] opacity-15' style={{ background: `linear-gradient(to bottom, transparent, ${ACCENT_BLUE}, transparent)`, filter: 'blur(1px)' }} />
      <div className='absolute end-[20%] top-[15%] h-1/4 w-[2px] opacity-15' style={{ background: `linear-gradient(to bottom, transparent, ${NOPING_GREEN}, transparent)`, filter: 'blur(1px)' }} />
      <div className='absolute end-[12%] top-[15%] size-48 rounded-full opacity-[0.07]' style={{ background: `radial-gradient(circle, ${ACCENT_BLUE}, transparent)`, filter: 'blur(40px)' }} />
      <div className='absolute bottom-[20%] start-[8%] size-40 rounded-full opacity-[0.06]' style={{ background: `radial-gradient(circle, ${NOPING_GREEN}, transparent)`, filter: 'blur(35px)' }} />
      <div className='absolute end-[40%] top-[60%] size-32 rounded-full opacity-5' style={{ background: `radial-gradient(circle, ${GOLD}, transparent)`, filter: 'blur(30px)' }} />
    </div>
  );
}
